<template>
  <div>
    <div
      class="card-deck"
      v-for="application in applications"
      :key="application.artifact"
    >
      <div
        class="card-wrapper"
        v-for="deployment in application.deployments"
        :key="deployment.environment"
      >
        <div class="card">
          <div class="card-header" :style="style[deployment.colorCode]">
            <div>
              <strong>{{ application.artifact }}</strong>
              <b-badge :class="deployment.colorCode">
                {{ deployment.environment }}
              </b-badge>
            </div>
          </div>
          <div class="card-body">
            <b-list-group flush>
              <b-list-group-item>
                <div class="d-flex w-100 justify-content-between">
                  <div class="text-muted">Build</div>
                  {{ deployment.build }}
                </div>
              </b-list-group-item>
              <b-list-group-item>
                <div class="d-flex w-100 justify-content-between">
                  <div class="text-muted">Commit</div>
                  {{ deployment.commitHash }}
                </div>
              </b-list-group-item>
              <b-list-group-item>
                <div class="d-flex w-100 justify-content-between">
                  <div class="text-muted">Deployed on</div>
                  {{ formatDate(deployment.deployedOn) }}
                </div>
              </b-list-group-item>
            </b-list-group>
          </div>
        </div>
        <b-icon-chevron-double-right
          class="seperater"
          v-if="deployment.environment !== 'US-PRD'"
        ></b-icon-chevron-double-right>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "QscoringBundles",
  data() {
    return {
      applications: []
    };
  },
  methods: {
    fetchApplications() {
      fetch("http://tools.pearsonclinical.com/events/qscoring-bundles").then(response =>
        response
          .json()
          .then(data => this.appendMissingEnvironments(data))
          .then(data => this.applyColor(data))
          .then(data => (this.applications = data))
          .then(() => console.log(this.applications))
          .catch(() => (this.applications = []))
      );
    },
    appendMissingEnvironments(artifacts) {
      artifacts.forEach(artifact => {
        let deployments = [];
        let deploymentMap = artifact.deployments.reduce((map, d) => {
          map[d.environment] = d;
          return map;
        }, {});
        this.environments.forEach(env => {
          if (deploymentMap[env.id]) {
            deployments.push(deploymentMap[env.id]);
          } else {
            deployments.push({
              build: "N/A",
              environment: env.id,
              commitHash: "N/A",
              deployedOn: "N/A"
            });
          }
        });
        artifact.deployments = deployments;
      });
      return artifacts;
    },
    applyColor(artifacts) {
      artifacts.forEach(artifact => {
        let deployments = [];
        let deploymentMap = artifact.deployments.reduce((map, d) => {
          map[d.environment] = d;
          return map;
        }, {});
        let colorCommitMap = {
          "N/A": "bg-secondary"
        };
        this.environments
          .slice()
          .reverse()
          .forEach(env => {
            let hash = deploymentMap[env.id].commitHash;
            colorCommitMap[hash] = colorCommitMap[hash]
              ? colorCommitMap[hash]
              : this.css[env.id];
            deploymentMap[env.id]["colorCode"] = colorCommitMap[hash];
            deploymentMap[env.id].environment = env.name;
            deployments.push(deploymentMap[env.id]);
          });
        artifact.deployments = deployments.reverse();
      });
      return artifacts;
    },
    formatDate(dateStr) {
      if (dateStr == "N/A") return dateStr;
      
      const date = new Date(dateStr);
      return (
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + date.getDate()).slice(-2) +
        "-" +
        date.getFullYear()
      );
    }
  },
  mounted() {
    this.fetchApplications();
    window.setInterval(() => {
      this.fetchApplications();
    }, 60000);
  },
  computed: {
    style() {
      return {
        "bg-secondary": { borderBottom: "2px solid #6c757d" },
        "bg-success": { borderBottom: "2px solid #28a745f0" },
        "bg-info": { borderBottom: "2px solid #17a2b8" },
        "bg-danger": { borderBottom: "2px solid #dc3545" },
        "bg-warning text-dark": { borderBottom: "2px solid #ffc107" }
      };
    },
    environments() {
      return [
        { id: "dev", name: "DEV" },
        { id: "us-dev", name: "US-DEV" },
        { id: "qa", name: "QA" },
        { id: "us-qa", name: "US-QA" },
        { id: "stg", name: "STG" },
        { id: "us-stg", name: "US-STG" },
        { id: "prd", name: "PRD" },
        { id: "us-prd", name: "US-PRD" }
      ];
    },
    css() {
      return {
        dev: "bg-danger",
        qa: "bg-warning text-dark",
        stg: "bg-info",
        prd: "bg-success",
        "us-dev": "bg-danger",
        "us-qa": "bg-warning text-dark",
        "us-stg": "bg-info",
        "us-prd": "bg-success"
      };
    }
  }
};
</script>
<style scoped>
.card-wrapper {
  display: flex;
}

.card-deck {
  margin: 20px 0 20px 10px;
  flex-flow: row;
  justify-content: center;
}

.card {
  flex: none;
  margin: 10px 15px 10px 15px;
  line-height: 0.5rem;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  width: 300px;
  transition: box-shadow 0.5s;
  border-bottom-right-radius: 20px;
  border-top-left-radius: 20px;
}

.card:hover {
  box-shadow: 0 2px 12px 5px rgba(10, 16, 20, 0.24),
    0 0 12px 5px rgba(10, 16, 20, 0.12);
}

.card-header {
  background-color: rgba(0, 0, 0, 0.05);
  border-top-left-radius: 20px;
}

.card-body {
  padding: 0.75rem 0.25rem;
}

.card-body .row {
  margin-right: 0;
  margin-left: 0;
  line-height: 1.75rem;
}

.badge {
  position: absolute;
  right: -20px;
  top: -10px;
  width: 50px;
  height: 30px;
  padding: 0.8em 0.4em;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
}

.seperater {
  padding: 85px 0 85px 0;
}
</style>
